import { Elements } from '@stripe/react-stripe-js'
import React, { useEffect, useRef, useState } from 'react'
import { loadStripe } from '@stripe/stripe-js'
import { PaymentAPI } from '../../api/PaymentAPI'
import {useSelector } from 'react-redux'
import CheckoutDetails from './CheckoutDetails'
import Loader from '../../component/Loader'
import PopUpAlert from '../../component/PopUpAlert'
import { useLocation, useNavigate } from 'react-router'
import { CalendarAPI } from '../../api/CalendarAPI'


const ReservationCheckout = () => {
    document.title = "Payment for reservation"
    const userInfo = useSelector((store) => store.user.userInfo);
    const selectedClub = useSelector((store) => store.user.selectedClub);
    const [stripePromise, setStripePromise] = useState(null);
    const hasFetchedRef = useRef(false);
    const [defaultCard, setDefaultCard] = useState('');
    const [isLoading, setIsLoading] = useState(false);
     const [isCheckoutEnable, setIsCheckoutEnable] = useState(false);
    const { state } = useLocation();
    const navigate = useNavigate();
    
    useEffect(() => {
        if (!hasFetchedRef.current) {
            hasFetchedRef.current = true;
            if (userInfo.userId && selectedClub.clubId) {
                getClientSecretForPayment();
                findCalendarConfigCheckout();
            }
        }
        if (userInfo.userId && selectedClub.clubId) {
            getDefaultCard();
        }
    }, [userInfo.userId, selectedClub.clubId]);
      const findCalendarConfigCheckout = async () => {
            try {
                const response = await CalendarAPI.getCalendarConfigCheckout(selectedClub.clubId);
                setIsCheckoutEnable(response.Data);
            } catch (error) {
                console.log(error);
            }
        };
    
    const getDefaultCard = async () => {
        try {
            setIsLoading(true);
            const defaultPaymentMethod = await PaymentAPI.fetchDefaultPaymentMethodData(userInfo?.userId, selectedClub.clubId);
            setDefaultCard(defaultPaymentMethod.Data);
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
        }
    }
    const getClientSecretForPayment = async () => {
        try {
            setIsLoading(true)
            const [publishKey, connectedId] = await Promise.allSettled([
                PaymentAPI.getPublishKey(),
                PaymentAPI.getAdminConnectedAccountId({ userId: state.reservationFor, clubId: selectedClub.clubId })
            ])
            setStripePromise(loadStripe(publishKey.value.Data, { stripeAccount: connectedId.value.Data }));

            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
        }

    }
    const appearance = {
        theme: 'flat',
        rules: {
            '.Input': {
                border: '1px solid rgba(156, 150, 150, 0.358)',
                boxShadow: 'none',
            },
            '.Input:focus': {
                border: '1px solid #8fbd04',
                boxShadow: 'none',
            },
            '.Input--invalid': {
                borderColor: '#df1b41',
            },
            '.Tab': {
                padding: '10px 15px',
                boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1),0 4px 6px -2px rgba(0, 0, 0, 0.05)'
            },
            '.Tab--selected': {
                backgroundColor: '#8fbd04',
                boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1),0 4px 6px -2px rgba(0, 0, 0, 0.05)'
            },
            '.Tab--selected:focus': {
                "outline": '2px solid #8fbd04',
                "boxShadow": 'none'
            },
            '.TabLabel': {
                color: '#30313d',
            },
            '.Label': {
                fontWeight: '500',
            },
        },
    };
    const options = {
        clientSecret: state?.clientSecret,
        appearance,
    };
    if(!state){
      navigate('/')
    }
    return (
        <div className='reservation_payment_container'>
            {isLoading && <Loader />}
            {state?.clientSecret && stripePromise && (
                <Elements stripe={stripePromise} options={options}>
                    <CheckoutDetails
                        isLoading={isLoading}
                        setIsLoading={setIsLoading}
                        defaultCard={defaultCard}
                        paymentIntentId={state?.paymentIntentId} 
                        priceDetails={state?.priceDetails} 
                        reservationFor={state?.reservationFor}
                        isCheckoutEnable={isCheckoutEnable}
                        />
                </Elements>
            )}
        </div>
    )
}

export default ReservationCheckout